import { AddressHelper } from '../helpers/AddressHelper';

const ADDRESS_TYPES = {
  HOUSE: 'house',
  WORK: 'work',
  HOLIDAY_HOUSE: 'holidayHouse',
  OTHER: 'other',
};

class Address {
  constructor(params) {
    this.additionalData = params.additionalData;
    this.addressType = params.addressType;
    this.apartment = params.apartment;
    this.bis = params.bis;
    this.cityName = !params.cityName ? null : {
      id: params.cityName.id,
      name: params.cityName.name,
    };
    this.coordinates = params.coordinates;
    this.approximated = params.approximated;
    this.deliveryDisabled = params.deliveryDisabled;
    this.department = !params.department ? null : {
      id: params.department.id,
      name: params.department.name,
    };
    this.doorNumber = params.doorNumber;
    this.extraInfo1 = !params.extraInfo1 ? null : {
      value: params.extraInfo1.value,
      field: !params.extraInfo1.field ? null : {
        id: params.extraInfo1.field.id,
        label: params.extraInfo1.field.label,
      },
    };
    this.extraInfo2 = !params.extraInfo2 ? null : {
      value: params.extraInfo2.value,
      field: !params.extraInfo2.field ? null : {
        id: params.extraInfo2.field.id,
        label: params.extraInfo2.field.label,
      },
    };
    this.firstCorner = params.corner1;
    this.id = params.id;
    this.letter = params.letter;
    this.secondCorner = params.corner2;
    this.streetName = params.streetName;
  }
}

class AddressNewApi {
  constructor(params) {
    this.id = params.id;
    this.addressType = AddressHelper.deSerializeType(params.type);
    this.street = params.mainStreet;
    this.streetName = params.mainStreetName;
    this.doorNumber = params.doorNumber;
    this.letter = params.letter;
    this.bis = params.bis;
    this.apartment = params.apartment;
    this.firstCorner = params.firstStreetName;
    this.firstCornerId = params.firstStreet;
    this.secondCorner = params.secondStreetName;
    this.secondCornerId = params.secondStreet;
    this.additionalData = params.description;
    this.cityName = {
      id: params.locality,
      name: params.localityName,
    };
    this.department = {
      id: params.department,
      name: params.departmentName,
    };
    this.coordinates = params.locationMap;
  }
}

export { Address, AddressNewApi, ADDRESS_TYPES };



// WEBPACK FOOTER //
// ./src/models/Address.js